import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { isPodcastProfile } from 'src/common/utils/guideItemTypes';
import isFollowingGuideId from '../../../../utils/isFollowingGuideId';
import FavoriteIconControl from './FavoriteIconControl';
import FavoriteIcon from './FavoriteIcon';
import FavoriteControlWithOptions from './FavoriteControlWithOptions';
import FavoriteStyleContext from './context/FavoriteStyleContext';

export function FavoriteControl({
  isPodcast,
  tunedGuideId,
  followOptions,
  iconClassName,
  isFollowing,
  primaryGuideId,
  unFavoritedClassName,
}) {
  return (
    <FavoriteStyleContext.Provider
      value={{ iconClassName, unFavoritedClassName }}
    >
      {isPodcast ? (
        <FavoriteControlWithOptions
          tunedGuideId={tunedGuideId}
          followOptions={followOptions}
          isFollowing={isFollowing}
        />
      ) : (
        <FavoriteIconControl guideId={primaryGuideId} isFollowing={isFollowing}>
          {(props) => <FavoriteIcon {...props} />}
        </FavoriteIconControl>
      )}
    </FavoriteStyleContext.Provider>
  );
}

FavoriteControl.propTypes = {
  isPodcast: PropTypes.bool.isRequired,
  followOptions: PropTypes.object.isRequired,
  tunedGuideId: PropTypes.string.isRequired,
  primaryGuideId: PropTypes.string.isRequired,
  isFollowing: PropTypes.bool.isRequired,
  iconClassName: PropTypes.string,
  unFavoritedClassName: PropTypes.string,
};

function mapStateToProps(state) {
  const { player, profiles } = state;
  const {
    followOptions,
    nowPlaying: { primaryGuideId = '' },
    tunedGuideId = '',
  } = player;

  const primaryInitialFollowState = get(
    followOptions,
    [primaryGuideId, 'isFollowing'],
    false,
  );
  const tunedGuideIdInitialFollowState = get(
    followOptions,
    [tunedGuideId, 'isFollowing'],
    false,
  );
  const isPodcast = isPodcastProfile(get(profiles, primaryGuideId, {}));
  const isFollowingPrimary = isFollowingGuideId(
    state,
    primaryGuideId,
    primaryInitialFollowState,
  );
  const isFollowingTunedGuideId = isFollowingGuideId(
    state,
    tunedGuideId,
    tunedGuideIdInitialFollowState,
  );
  const isFollowing = isPodcast
    ? isFollowingPrimary || isFollowingTunedGuideId
    : isFollowingTunedGuideId;

  return {
    isPodcast,
    tunedGuideId,
    followOptions,
    primaryGuideId,
    isFollowing,
  };
}

export default connect(mapStateToProps)(FavoriteControl);
